module.exports = __webpack_public_path__ + "img/logo_sirka.65214a11.png";